module.exports = __webpack_public_path__ + "static/media/end-blood-and-imaging-badge.828a3a25.svg";